import { graphql } from 'react-apollo'
import { REMOVE_FROM_PLAYLIST } from '../../graphql/mutations'

export default graphql(REMOVE_FROM_PLAYLIST, { name: 'DetachFiles' })
